import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { OrganizationSearchResponse } from '../../models/civi-crm/organization-search-response';

@Injectable({
    providedIn: 'root',
})
export class OrganizationService {
    private readonly baseUrl = 'api/Organizations';

    constructor(private readonly http: HttpClient) {}

    searchOrganizations(query: string): Promise<OrganizationSearchResponse[]> {
        return lastValueFrom(
            this.http.post<OrganizationSearchResponse[]>(
                `${this.baseUrl}/search`,
                {
                    searchText: query,
                },
            ),
        );
    }
}
